<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "Forget Password" | translate }}</h3>
    <p class="mt-5">
      {{ "Enter your phone number to send OTP code to reset your password" | translate }}
    </p>
    <label>{{ "Phone Number" | translate }}</label>
    <div class="input-container mt-1">
      <i class="bi bi-phone left-icon"></i>
      <input
        type="tel"
        [(ngModel)]="phone"
        placeholder="{{ 'Enter your phone number' | translate }}"
      />
    </div>

    <button (click)="forgetPassword()" class="w-100 mt-5 btn">
      {{ "Send OTP Code" | translate }}
    </button>

    <div class="text-center mt-4">
      {{ "Login with another account?" | translate }}
      <span class="bold-text" [routerLink]="'/' + lang + '/login'">
        {{ "Login" | translate }}
      </span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 pt-5 right-container">
    <img width="50%" [src]="logo" />
  </div>
</div>

<div class="modal-overlay" *ngIf="showModal">
  <div class="modal-box">
    <button class="modal-close" (click)="showModal = false">
      <i class="bi bi-x-lg"></i>
    </button>
    <div class="modal-icon">
      <i class="bi bi-phone-fill"></i>
    </div>
    <h5>{{ "Check your phone" | translate }}</h5>
    <p>
      {{ "We sent an OTP code to" | translate }}
      <span class="bold-text">{{ phone }}</span>
      {{ "Check your messages and enter the code." | translate }}
    </p>
  </div>
</div>